function initProductSwiper(section) {
    const mainEl = section.querySelector('.pdp-image-metafield-slide');
    const thumbEl = section.querySelector('.thumb-swiper');
    if (!mainEl || !thumbEl) return;
    if (mainEl.classList.contains('swiper-initialized')) return;
    const thumbSwiper = new Swiper(thumbEl, {
        spaceBetween: 4,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
    });

    const nextBtn = mainEl.querySelector('.swiper-button--next');
    const prevBtn = mainEl.querySelector('.swiper-button--prev');
    const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        loop: true,
        effect: 'fade',

        navigation: (nextBtn && prevBtn) ? {
            nextEl: nextBtn,
            prevEl: prevBtn
        } : {},

        thumbs: {
            swiper: thumbSwiper,
        },

        on: {
            slideChange: function () {
                const index = this.realIndex;

                thumbSwiper.slideTo(index);

                // Active class
                thumbSwiper.slides.forEach(slide => {
                    slide.classList.remove('swiper-slide-thumb-active');
                });

                if (thumbSwiper.slides[index]) {
                    thumbSwiper.slides[index].classList.add('swiper-slide-thumb-active');
                }
            }
        }
    });
    thumbSwiper.on('click', function () {
        const clickedIndex = thumbSwiper.clickedIndex;

        if (clickedIndex !== undefined) {
            mainSwiper.slideToLoop(clickedIndex);
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(section => {
        initProductSwiper(section);
    });
});

document.addEventListener('shopify:section:load', function (event) {
    initProductSwiper(event.target);
});
